// extracted by mini-css-extract-plugin
export default {"main_heading":"style_main_heading__FYlvJ","wlcm_heading":"style_wlcm_heading__5BbN1"};